import React, { useEffect, useState } from 'react'
import { Table, Tag, Modal, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import FormZ from '../components/FormZ';

import { sendNotify } from '../helper/notification'
import authRep from '../repository/authRep'

export default function Settings() {
  let details = useSelector((state) => state.auth.userDetails)

  const [togglePass, setTogglePass] = useState(false)
  const [togglePass1, setTogglePass1] = useState(false)
  const [togglePass2, setTogglePass2] = useState(false)
  const [password, setPassword] = useState('')
  const [oldPassword, setOldPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')


  const updateDetails = () => {
    let obj = {};
    if (password && oldPassword) {
      if (confirmPassword === password) {
        obj['newPassword'] = password
        obj['oldPassword'] = oldPassword
        obj['email'] = details.email
        authRep.updatePass(obj).then(response => {
          if (response) {
            if (response.error) {
              sendNotify('error', response.error?.response?.data?.message)
            } else {
              sendNotify('success', response?.message)
            }
          }
        })
          .catch(error => ({ error: JSON.stringify(error) }));
      } else {
        sendNotify('error', 'The given passwords do not match.')
      }
    }
  }


  return (
    <section className='mt-md-3'>
      <div className='container-fluid px-0'>
        <div className="row gy-4  justify-content-center">
          <div className="col-md-4">
            <div className="page-header text-center" style={{ display: "block" }}>
              <h1>Change Passowrd</h1>
            </div>
            <div className="chart-box" style={{ height: "auto" }}>
              <div className='auth-form'>
                <div className="input-box">
                  <label htmlFor="password">Old Password</label>
                  <div className='input-field'>
                    <input type={togglePass1 ? 'text' : 'password'} name='password' id='password' placeholder='Enter your password' value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                    <button className='input-after color-primary' onClick={() => setTogglePass1(!togglePass1)}>
                      <i className={`far ${togglePass1 ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>
                <div className="input-box">
                  <label htmlFor="password">New Password</label>
                  <div className='input-field'>
                    <input type={togglePass2 ? 'text' : 'password'} name='password' id='password' placeholder='Enter your password' onChange={(e) => setPassword(e.target.value)} />
                    <button className='input-after color-primary' onClick={() => setTogglePass2(!togglePass2)}>
                      <i className={`far ${togglePass2 ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>
                <div className="input-box">
                  <label htmlFor="password">Confirm Password</label>
                  <div className='input-field'>
                    <input type={togglePass ? 'text' : 'password'} name='password' id='password' placeholder='Enter your password' onChange={(e) => setConfirmPassword(e.target.value)} />
                    <button className='input-after color-primary' onClick={() => setTogglePass(!togglePass)}>
                      <i className={`far ${togglePass ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>
                <div className="text-center mt-4 ">
                  <button className='primary-btn ms-2' onClick={() => updateDetails()}><i className="far fa-save"></i> Save <span className='d-none d-md-inline'>&nbsp;changes</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  )
}
